import { Pipe, PipeTransform } from '@angular/core';
import { Web3Service } from '@/services/web3.service';

@Pipe({
  standalone: true,
  name: 'wei'
})
export class WeiPipe implements PipeTransform {

  constructor(
    private web3Svc: Web3Service
  ) {}

  transform(value: string): number {
    // console.log({ value });

    const eth = value ? this.web3Svc.weiToEth(`${value}`) : '0';
    return parseFloat(eth);
  }

}
